import axios from 'axios';
import { event } from 'jquery';
import React, { useState, useRef } from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import { API } from '../../../config/API';
import Loader from '../../../components/Loader/Loader';
import ToastComp from '../../../components/Toast/Toast';
import { serialize } from 'object-to-formdata';
import toast from 'react-hot-toast';

function AddTrainingQuestion(arg) {
  const [show, setShow] = useState(arg.flag);
  const [imageSource, setImageSource] = useState(""); 
  const [imageSource2, setImageSource2] = useState("");
  const [qstn, setQstn] = useState("");
  const [desc, setDesc] = useState("");
  const [image1Desc, setImage1Desc] = useState("");
  const [image2Desc, setImage2Desc] = useState("");
  const [loader, setLoader] = useState(false);
  const [addAlert, setAddAlert] = useState(false);
  const [errorToggle, setErrorToggle] = useState(false);

  const img1 = useRef('');
  const img2 = useRef('');





  const handleClose = () => {
    setShow(false);
    arg.handler();
  }
  const handleShow = () => setShow(true);

  const loadImage = (event) =>{
    img1.current = event.target.files[0];
    setImageSource(URL.createObjectURL(event.target.files[0]));
  }
  const loadImage2 = (event) =>{
    img2.current = event.target.files[0];
    setImageSource2(URL.createObjectURL(event.target.files[0]));
  }
  const addQuestion =()=>{
    setShow(false);
    setLoader(true);
    const req={
      trainingId: arg.id,
      data : [
        {
           question : qstn,
          description: desc,
          image1: img1.current,
          image2: img2.current,
          imageText1 : image1Desc,
          imageText2 : image2Desc
        }
      ]
    }

    //const formData = serialize(req);
    const formData = new FormData();

    formData.append("trainingId", arg.id );
    formData.append("data[0].question", qstn);
    formData.append("data[0].description", desc);
    formData.append("data[0].image1", img1.current);
    formData.append("data[0].image2", img2.current);
    formData.append("data[0].image1Description", image1Desc);
    formData.append("data[0].image2Description", image2Desc);
   

    axios.post(API.addTrainingQuestion, formData ,{
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }).then((res)=>{
      if(res && res.data && res.data.status ==="S"){
        // setAddAlert(true);
        toast.success('Question added successfully.');
      }else{
        // setErrorToggle(true);
        toast.error('Failed to add question.');
      }
    }).catch((error)=>{
      // setErrorToggle(true)
      toast.error('An error occurred while adding question.');
    }).finally(()=>{
      setTimeout(() => {
        setLoader(false);
        arg.handler();
      }, 1000);
    })

  }
  return (
    <>
      <Loader loading={loader}></Loader>
      {addAlert ? <ToastComp case='question-add' handler={()=>{setAddAlert(false)}}/> : ""}
      {errorToggle ? <ToastComp case='error' handler={()=>{setErrorToggle(false)}}/> : ""}
      <Modal show={show} onHide={handleClose} size="lg"  backdrop="static" keyboard={false}>
        <Modal.Header>
          <Modal.Title>Add Training Question</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <Form.Label>Question</Form.Label>
              <Form.Control
                type="text" autoFocus value={qstn} onChange={(e)=>setQstn(e.target.value)}
              />
            </Form.Group>
            <Form.Group
              className="mb-3"
              controlId="exampleForm.ControlTextarea1"
            >
              <Form.Label>Description</Form.Label>
              <Form.Control as="textarea" rows={2} value={desc} onChange={(e)=>setDesc(e.target.value)}/>
            </Form.Group>
            <div className='row'>
            <Form.Group
              className="mb-3 col-md-6"
              controlId="exampleForm.ControlTextarea1"
            >
              <Form.Label>Upload Image 1(Wrong Practice)</Form.Label>
              <Form.Control type="file" className='form-control' accept="image/png, image/jpeg" onChange={(event)=>loadImage(event)}/>
              <img id="output" width="200" height="200" src={imageSource}/>
              <Form.Control as="textarea" className=' mt-1' rows={2} value={image1Desc} onChange={(e)=>setImage1Desc(e.target.value)} />
            </Form.Group>
            <Form.Group
              className="mb-3 col-md-6"
              controlId="exampleForm.ControlTextarea1"
            >
              <Form.Label>Upload Image 2(Right Practice)</Form.Label>
              <Form.Control type="file" className='form-control' accept="image/png, image/jpeg" onChange={(event)=>loadImage2(event)}/>
              <img id="output" width="200" height="200" src={imageSource2}/>
              <Form.Control as="textarea" className=' mt-1' rows={2} placeholder='Description' onChange={(e)=>setImage2Desc(e.target.value)} value={image2Desc}/>
            </Form.Group>
            </div>
            
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            CANCEL
          </Button>
          <Button variant="primary" onClick={addQuestion}>
            SAVE
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default AddTrainingQuestion;

